<template>
    <span class="number-input">
        <span class="value">{{ value }}</span>
        <span class="btn-group-arrows">
            <button @click.stop="increase" class="btn-number btn-primary plus"
                    :style="isDisabled ? 'background-color: #D4E4F0' : ''"></button>
            <button @click.stop="decrease" class="btn-number btn-primary minus"></button>
        </span>
    </span>
</template>

<script>
export default {
  name: "NumberInput",
  props: {
    value: {
      required: true,
      type: Number,
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 99
    }
  },
  computed: {
    isDisabled() {
      return this.value === this.max;
    }
  },
  methods: {
    decrease() {
      const newValue = this.value - 1;
      if (newValue < this.min) return;
      this.$emit('valueChange', newValue);
    },
    increase() {
      const newValue = this.value + 1;
      if (this.max !== undefined && newValue > this.max) {
        return;
      }
      this.$emit('valueChange', newValue);
    },
  },
}
</script>

<style scoped lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
  -moz-appearance: textfield; /* Firefox */
}

.number-input {
  display: flex;
  min-width: 52px;
  width: 62px;
  height: 34px;
  box-sizing: border-box;
  border: 2px solid #EBEBEB;
  background: #fff;

  border-radius: 25px;

  .value {
    display: block;
    flex: 3 0 0;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
  }

  .btn-group-arrows {
    display: flex;
    flex-direction: column;
    height: 30px;
    width: 18px;
    flex: 2 0 0;

    .btn-number {
      width: 23px;
      height: 16px;
      font-size: 10px;
      line-height: 8px;
      text-align: center;
      position: relative;
      padding: 0;
      outline: none;

      &:focus {
        box-shadow: none;
      }

      &.minus {
        border-left: 1px solid #3db0c7;
        border-top: 1px solid #3db0c7;
        border-right: none;
        border-bottom: none;
      }

      &.plus {
        border-left: 1px solid #3db0c7;
        border-top: none;
        border-right: none;
        border-bottom: none;
      }

      &.minus,
      &.plus {
        transition: all ease 0.2s;

        &:hover {
          background-color: lighten(#3DB0C7, 40%);
        }

        &:active:focus {
          box-shadow: none;
        }

        &:after,
        &:before {
          content: "";
          position: absolute;
          background: #3DB0C7;
          top: 50%;
          left: 40%;
          transform: translateY(-50%) translateX(-50%);
        }

        &:after {
          width: 8px;
          height: 2px;
        }

        &:before {
          width: 2px;
          height: 8px;
        }
      }

      &.plus {
        background-color: #FFF;
        border-radius: 25px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;

        &:hover {
          background-color: lighten(#3DB0C7, 40%);
        }
      }

      &.minus {
        background-color: #FFF;
        border-radius: 25px;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;

        &:before {
          display: none;
        }
      }
    }
  }
}
</style>
